import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { Grid } from '@mui/material';
import React, { useContext } from 'react';
import { SelectorGeneric } from '../common/DeviceGenerics';
import { DeviceLinkContext } from './DeviceLinkContext';
const LinkingType = (props) => {
    const { setSelectedEntity } = props;
    const { allowEntities, entityOptions, selectedEntityType } = useContext(DeviceLinkContext);
    return (_jsx("div", { children: _jsxs(Grid, { id: 'Device-Supported-Entities', container: true, size: { xs: 12 }, 
            // spacing={2}
            sx: {
                justifyContent: 'flex-start',
                alignItems: 'center',
            }, children: [_jsx(Grid, { size: { xs: 4 }, children: _jsx(Typography, { variant: "body2", component: "p", color: "primary", children: `4) Type` }) }), _jsx(Grid, { size: { xs: 8 }, sx: { flexGrow: 1 }, children: setSelectedEntity && (_jsx(SelectorGeneric, { disabled: entityOptions?.length < 2 || !allowEntities, description: "Entity", choices: entityOptions, choice: selectedEntityType, choose: setSelectedEntity })) })] }) }));
};
export default LinkingType;
